import { render, staticRenderFns } from "./NewUserWelcome.vue?vue&type=template&id=5cac29cb&scoped=true&"
import script from "./NewUserWelcome.vue?vue&type=script&lang=js&"
export * from "./NewUserWelcome.vue?vue&type=script&lang=js&"
import style0 from "./NewUserWelcome.vue?vue&type=style&index=0&id=5cac29cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac29cb",
  null
  
)

export default component.exports